import { render, staticRenderFns } from "./couponCenter.vue?vue&type=template&id=550ab270&"
import script from "./couponCenter.vue?vue&type=script&lang=js&"
export * from "./couponCenter.vue?vue&type=script&lang=js&"
import style0 from "./couponCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports